// extracted by mini-css-extract-plugin
module.exports = {"header":"OrganizeLearnings_header__2IEOf","p":"OrganizeLearnings_p__2goe6"};